import React from 'react';
import { Button, Grid, Header, Segment } from 'semantic';
import ThemedSegment from 'components/semantic/Segment';
import { FormikState } from 'formik';
import { ChargingPolicy } from 'screens/GroupsAndPolicies/types';
import { useTranslation } from 'react-i18next';
import { TariffPreview } from 'screens/GroupsAndPolicies/Tariff/TariffPreview';
import { CustomTariffRulePreview } from 'screens/GroupsAndPolicies/ChargingPolicy/CustomTariffRulePreview';

type Props = {
  values?: FormikState<ChargingPolicy>['values'];
};

export function PricingPreview({ values }: Props) {
  const { t } = useTranslation();

  if (
    !Object.keys(values?.defaultTariff || {}).length &&
    !values?.customTariffRules?.length
  ) {
    return (
      <ThemedSegment offbackground>
        <p>
          {t(
            'chargingPolicyForm.noTariffsToDisplay',
            'There are no tariffs to display.'
          )}
        </p>
        <Button
          basic
          icon="plus"
          content={t(
            'chargingPolicyForm.pricing.addDefaultTariffButton',
            'Add Default Tariff'
          )}
        />
        <Button
          basic
          icon="plus"
          content={t(
            'chargingPolicyForm.pricing.addCustomTariffButton',
            'Add Custom Tariff'
          )}
        />
      </ThemedSegment>
    );
  }

  return (
    <Segment>
      {Object.keys(values?.defaultTariff || {}).length && (
        <>
          <Header
            as="h4"
            content={t(
              'chargingPolicyForm.pricing.defaultTariffTitle',
              'Default Tariff'
            )}
          />
          <TariffPreview values={values?.defaultTariff} />
        </>
      )}

      {!Object.keys(values?.defaultTariff || {}).length && (
        <Button
          basic
          icon="plus"
          content={t(
            'chargingPolicyForm.pricing.addDefaultTariffButton',
            'Add Default Tariff'
          )}
        />
      )}

      {values?.customTariffRules?.length && (
        <Header
          as="h4"
          content={t(
            'chargingPolicyForm.pricing.customTariffRulesTitle',
            'Custom Tariff'
          )}
        />
      )}
      {values?.customTariffRules?.map((customTariffRule, index) => {
        return (
          <CustomTariffRulePreview key={index} values={customTariffRule} />
        );
      })}

      <Button
        basic
        icon="plus"
        content={t(
          'chargingPolicyForm.pricing.addCustomTariffButton',
          'Add Custom Tariff'
        )}
      />
    </Segment>
  );
}
